import { createSelector } from 'reselect';

export const getTags = (state) => state.tags.data;
export const getTagsSuggestions = (state) => state.tags.suggestions;

export const getTagsOptions = createSelector(
  getTagsSuggestions,
  (items) => items.map(({ name, id }) => ({ id, name })),
);

export const getTagsLabelMap = createSelector(
  getTags,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [id]: name }), {}),
);

export const getTagsLabelToIDMap = createSelector(
  getTags,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [name]: id }), {}),
);

export const getTagsLoadingState = ({ tags }) => tags.loading;
